
    import {
      getAllStudentRequirementSubmissions,
      createStudentRequirementSubmission,
      createAllStudentRequirementSubmissions,
      updateStudentRequirementSubmission,
      deleteStudentRequirementSubmission
    } from "@/services/studentRequirementSubmission";

    const state = {
      studentRequirementSubmissions: [],
      processed: false
    };

    const getters = {
      getStudentRequirementSubmissions(state) {
        return state.studentRequirementSubmissions;
      },
      studentRequirementSubmissionProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchStudentRequirementSubmissions({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllStudentRequirementSubmissions(
              params
            )
              .then(response => {
                commit("SET_STUDENTREQUIREMENTSUBMISSIONS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createStudentRequirementSubmission({ commit }, studentRequirementSubmission) {
          return new Promise((resolve, reject) => {
            createStudentRequirementSubmission(studentRequirementSubmission)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllStudentRequirementSubmissions({ commit }, studentRequirementSubmissions) {
          return new Promise((resolve, reject) => {
            createAllStudentRequirementSubmissions(studentRequirementSubmissions)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateStudentRequirementSubmission({ commit }, studentRequirementSubmission) {
          return new Promise((resolve, reject) => {
            updateStudentRequirementSubmission(studentRequirementSubmission)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteStudentRequirementSubmission({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteStudentRequirementSubmission(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_STUDENTREQUIREMENTSUBMISSIONS(state, data) {
        state.studentRequirementSubmissions = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    